import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import { withRouter, Link } from 'react-router-dom';
import { RouterHistory } from 'react-router';
import { Hidden, Tooltip } from '@material-ui/core';
import { compose } from '../../utility';
import Logo from '../../assets/real-sign.svg';
import styles from './navbar.styles';
import Button from '../../shared/button/button';
import Signature from '../../assets/signature.svg';
import AccountMenu from '../../shared/accountSettings/accountMenu';
import { AppUser } from '../../shared/authorization';
import { withAppUser } from '../../shared/authorization';
import Cookies from 'js-cookie';

type PropType = {
  classes: Object,
  history: RouterHistory,
  user: AppUser,
  trialActive?: ?boolean,
  subscriptionExpired?: boolean,
  onStartSigning?: (history: RouterHistory) => void,
};

class Navbar extends React.PureComponent<PropType, null> {
  handleStartSigning = () => {
    const { history, trialActive, onStartSigning } = this.props;
    if (onStartSigning) {
      onStartSigning(history);
      return;
    }
    if (trialActive === false) {
      return;
    }
    history.push('/agent/sessions/new');
  };

  render() {
    const { classes, user, title, trialActive } = this.props;
    const titleButton = Cookies.get('sessionFile') ? 'Continue' : 'Start';
    const signingDisabled = trialActive == null;
    return (
      <AppBar classes={{ root: classes.root }} elevation={0}>
        <Link
          to="/agent/sessions"
          className={classes.logoLink}
          aria-label="Signing sessions"
        >
          <Logo className={classes.logo} />
        </Link>
        <Hidden smDown>
          <h1 className={classes.title}>{title || 'Signing Sessions'}</h1>
        </Hidden>
        <div className={classes.buttons}>
          <Button
            color="primary"
            classes={{
              button: classes.button,
            }}
            disableFocusRipple
            disabled={signingDisabled}
            onClick={this.handleStartSigning}
          >
            <Signature className={classes.startSigningIcon} />
            <Hidden xsDown>{titleButton} Signing</Hidden>
          </Button>

          <AccountMenu user={user} />
        </div>
      </AppBar>
    );
  }
}

export default compose(
  withAppUser,
  withStyles(styles, { withTheme: true }),
  withRouter
)(Navbar);
